import { useParams } from 'react-router-dom'
import { AdminShell } from '../components/admin/AdminShell'
import { EventAdminTabs } from '../components/admin/EventAdminTabs'
import { OccurrenceManagement } from '../components/management/OccurrenceManagement'
import { useChurch } from '../hooks/useChurches'
import { useSubscriptionStatus, useOccurrenceRsvps } from '../hooks/useChurchAdmin'

export default function HostManagementPage() {
  const { slug, occurrenceId } = useParams<{ slug: string; occurrenceId: string }>()
  const { data: churchData } = useChurch(slug)
  const church = churchData?.data
  const { data: subData } = useSubscriptionStatus(church?.id)
  const tier = subData?.data.tier
  const { data: occData } = useOccurrenceRsvps(occurrenceId)
  const event = occData?.data.event
  const occurrence = occData?.data.occurrence

  // Default unlocked until subscription loads — avoids a flash of locked state
  const canBroadcast = !tier || tier === 'community' || tier === 'connection'

  return (
    <AdminShell>
      {slug && event && occurrence && (
        <EventAdminTabs
          slug={slug}
          eventId={event.id}
          occurrenceId={occurrence.id}
          title={event.title}
          startsAt={occurrence.startsAt}
          active="guests"
        />
      )}
      {occurrenceId && (
        <OccurrenceManagement
          occurrenceId={occurrenceId}
          canBroadcast={canBroadcast}
          upgradeUrl={slug ? `/churches/${slug}/billing` : undefined}
        />
      )}
    </AdminShell>
  )
}
